<template>
  <div class="radio-label"><v-textarea></v-textarea></div>
  <!--<div class="radio-label">
    <v-radio-group>
      <v-radio
        v-for="(option, index) in options"
        :key="index"
        :label="option"
        :value="index"
        v-model="selectedOption"
        class="radio-input radio-label"
        base-color="#848484"
        color="#fa6363"
      >
      </v-radio>
    </v-radio-group>
  </div>-->
</template>

<script>
export default {
  name: "ََAnswerBox",
  props: {
    options: {
      type: Array,
      required: true,
    },
    groupName: {
      type: String,
      required: false,
      default: "radio-group",
    },
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  watch: {
    selectedOption(newValue) {
      this.$emit("update:selectedOption", newValue);
    },
  },
};
</script>

<style scoped lang="scss">
.v-selection-control--dirty {
  background-color: $c_jet_gray;
  min-width: 800px;
}

.radio-label {
  min-width: 800px;
  width: 100%;
}

.radio-input label {
  width: 100% !important;
}

.radio-input {
  border: 1px solid $c_battleship_grey1;
  border-radius: 5px;
  margin-bottom: 5px;
}

.radio-custom {
  width: 20px;
  height: 20px;
  border: 2px solid $c_battleship_grey1;
  border-radius: 50%;
  position: relative;
  display: inline-block;
}

.radio-custom::after {
  content: "";
  width: 10px;
  height: 10px;
  background-color: $c_bittersweet;
  border: 2px solid $c_bittersweet;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.radio-input:checked + .radio-custom::after {
  opacity: 1;
}

.radio-text {
  font-size: 16px;
  color: $c_white_smoke;
}
</style>
